import { useMemo, useState } from 'react';

export function useTableSort<T, TSort extends string>(
  items: T[],
  defaultSort: TSort,
  comparer: (
    a: T,
    b: T,
    sortBy: TSort
  ) => number
) {
  const [sortBy, setSortBy] = useState<TSort>(defaultSort);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const handleSort = (column: TSort) => {
    const isAsc = sortBy === column && sortDirection === 'asc';

    setSortBy(column);
    setSortDirection(isAsc ? 'desc' : 'asc');
  };

  const sortedItems = useMemo(() => {
    return [...items].sort((a, b) => {
      const baseComparison = comparer(a, b, sortBy);
      return sortDirection === 'asc' ? baseComparison : -baseComparison;
    });
  }, [items, sortBy, sortDirection, comparer]);

  return {
    sortedItems,
    sortBy,
    sortDirection,
    handleSort,
  };
}